import funds from '@/api/modules/funds'

const getDefaultState = () => {
  return {
    map: {}
  }
}

const state = getDefaultState()

const actions = {
  fetch (context, isin) {
    return funds.fetch(isin)
      .then(data => context.commit('fetch', { isin, data }))
  },

  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  fetch (state, { isin, data }) {
    state.map = {
      ...state.map,
      [isin]: data
    }
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  getByISIN: ({ map }) => (isin) => {
    return map[isin]
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
